import { f as _objectSpread2, _ as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import '@styled-system/color';
import '@styled-system/variant';
import '@styled-system/typography';
import { T as Text } from './text-5e5c8ea1.js';

function GroupInstagramIcon(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement("svg", {
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      WebkitTransform: "translate3d(0,0,0)"
    }),
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_606)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "28",
    r: "24",
    fill: "#C30198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 16C14.9907 16 12 18.9907 12 22.6667V33.3333C12 37.0093 14.9907 40 18.6667 40H29.3333C33.0093 40 36 37.0093 36 33.3333V22.6667C36 18.9907 33.0093 16 29.3333 16H18.6667ZM18.6667 18.6667H29.3333C31.5387 18.6667 33.3333 20.4613 33.3333 22.6667V33.3333C33.3333 35.5387 31.5387 37.3333 29.3333 37.3333H18.6667C16.4613 37.3333 14.6667 35.5387 14.6667 33.3333V22.6667C14.6667 20.4613 16.4613 18.6667 18.6667 18.6667ZM30.6667 20C30.313 20 29.9739 20.1405 29.7239 20.3905C29.4738 20.6406 29.3333 20.9797 29.3333 21.3333C29.3333 21.687 29.4738 22.0261 29.7239 22.2761C29.9739 22.5262 30.313 22.6667 30.6667 22.6667C31.0203 22.6667 31.3594 22.5262 31.6095 22.2761C31.8595 22.0261 32 21.687 32 21.3333C32 20.9797 31.8595 20.6406 31.6095 20.3905C31.3594 20.1405 31.0203 20 30.6667 20ZM24 21.3333C20.324 21.3333 17.3333 24.324 17.3333 28C17.3333 31.676 20.324 34.6667 24 34.6667C27.676 34.6667 30.6667 31.676 30.6667 28C30.6667 24.324 27.676 21.3333 24 21.3333ZM24 24C26.2053 24 28 25.7947 28 28C28 30.2053 26.2053 32 24 32C21.7947 32 20 30.2053 20 28C20 25.7947 21.7947 24 24 24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_606",
    x: "0",
    y: "0",
    width: "56",
    height: "56",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: "4"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_606"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1161_606",
    result: "shape"
  }))));
}
GroupInstagramIcon.propTypes = {
  style: PropTypes.object
};
GroupInstagramIcon.defaultProps = {
  style: {}
};
GroupInstagramIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GroupInstagramIcon",
  "props": {
    "style": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

function GroupWhatsappIcon(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement("svg", {
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      WebkitTransform: "translate3d(0,0,0)"
    }),
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2425_380)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "28",
    r: "24",
    fill: "url(#paint0_linear_2425_380)"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.6151 22.0053C22.3531 21.4326 22.0774 21.4212 21.8282 21.4112C21.6243 21.4026 21.391 21.4031 21.158 21.4031C20.9248 21.4031 20.546 21.4892 20.2256 21.8333C19.905 22.1774 19.0015 23.0092 19.0015 24.701C19.0015 26.3929 20.2547 28.0277 20.4294 28.2573C20.6043 28.4866 22.8486 32.0692 26.403 33.4475C29.357 34.593 29.9581 34.3651 30.5993 34.3078C31.2405 34.2505 32.6683 33.4762 32.9597 32.6732C33.2511 31.8704 33.2511 31.1822 33.1637 31.0384C33.0763 30.8951 32.8431 30.8091 32.4934 30.6372C32.1436 30.4652 30.4245 29.6332 30.1039 29.5186C29.7833 29.404 29.5501 29.3467 29.317 29.6909C29.0838 30.0348 28.414 30.8091 28.21 31.0384C28.006 31.2682 27.802 31.2969 27.4522 31.1249C27.1025 30.9524 25.9762 30.5897 24.6401 29.4183C23.6005 28.5069 22.8987 27.3814 22.6947 27.0371C22.4907 26.6932 22.6728 26.5069 22.8482 26.3355C23.0052 26.1815 23.198 25.9341 23.3728 25.7333C23.5473 25.5325 23.6056 25.3892 23.7222 25.16C23.8388 24.9303 23.7805 24.7296 23.6931 24.5576C23.6056 24.3857 22.926 22.6852 22.6151 22.0053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0129 18.0346C33.3704 15.4344 29.8566 14.0016 26.113 14C18.3986 14 12.1206 20.1713 12.1175 27.7566C12.1166 30.1813 12.7609 32.5482 13.9855 34.6345L12 41.7633L19.4192 39.8503C21.4633 40.9465 23.7648 41.5242 26.107 41.525H26.1129H26.113C33.8261 41.525 40.105 35.3527 40.1083 27.7677C40.1096 24.0916 38.6551 20.635 36.0129 18.0346ZM26.113 39.2016H26.1084C24.0208 39.2005 21.9735 38.6494 20.1879 37.6075L19.7629 37.3597L15.3602 38.4948L16.5356 34.2754L16.2588 33.8428C15.0943 32.0221 14.4795 29.918 14.4804 27.7575C14.4829 21.4528 19.701 16.3237 26.1174 16.3237C29.2246 16.3249 32.1449 17.5159 34.3413 19.6771C36.5375 21.8383 37.7461 24.7113 37.7452 27.7669C37.7425 34.0717 32.5243 39.2016 26.113 39.2016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2425_380",
    x: "0",
    y: "0",
    width: "56",
    height: "56",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: "2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2425_380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2425_380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2425_380",
    x1: "26",
    y1: "52",
    x2: "26",
    y2: "4.00008",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    "stop-color": "#60D66A"
  }))));
}
GroupWhatsappIcon.propTypes = {
  style: PropTypes.object
};
GroupWhatsappIcon.defaultProps = {
  style: {}
};
GroupWhatsappIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GroupWhatsappIcon",
  "props": {
    "style": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

function GroupMessengerIcon(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/React.createElement("svg", {
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      WebkitTransform: "translate3d(0,0,0)"
    }),
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1152_633)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "28",
    r: "24",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 14.2857C18.2748 14.2857 12.2861 19.9449 12.2861 27.5886C12.2861 31.587 13.9246 35.0416 16.5931 37.4286C16.7044 37.527 16.7945 37.6471 16.8578 37.7815C16.9212 37.9159 16.9565 38.0618 16.9617 38.2103L17.0364 40.6514C17.0419 40.831 17.0915 41.0066 17.1808 41.1626C17.27 41.3185 17.3962 41.4502 17.5483 41.546C17.7003 41.6418 17.8736 41.6988 18.0528 41.7119C18.2321 41.725 18.4118 41.694 18.5762 41.6214L21.2981 40.4214C21.5288 40.3197 21.7875 40.3008 22.0305 40.3679C23.3244 40.7195 24.6596 40.8956 26.0004 40.8914C33.726 40.8914 39.7147 35.2343 39.7147 27.5886C39.7147 19.9428 33.726 14.2857 26.0004 14.2857ZM34.2358 24.521L30.2073 30.9143C30.0557 31.1547 29.856 31.3611 29.6207 31.5205C29.3854 31.6798 29.1196 31.7887 28.8401 31.8403C28.5607 31.8918 28.2735 31.8849 27.9969 31.8199C27.7202 31.755 27.46 31.6334 27.2326 31.4628L24.0286 29.0594C23.8855 28.9521 23.7114 28.8944 23.5325 28.895C23.3537 28.8955 23.1799 28.9543 23.0374 29.0625L18.7099 32.3454C18.1325 32.7835 17.3786 32.0923 17.765 31.479L21.7936 25.0874C21.9451 24.847 22.1448 24.6406 22.3801 24.4812C22.6154 24.3219 22.8812 24.213 23.1607 24.1614C23.4402 24.1099 23.7273 24.1168 24.004 24.1818C24.2806 24.2467 24.5408 24.3683 24.7682 24.5388L27.9725 26.9419C28.1156 27.0492 28.2898 27.1069 28.4686 27.1064C28.6475 27.1058 28.8213 27.047 28.9637 26.9388L33.2909 23.655C33.8686 23.2164 34.6226 23.9076 34.2358 24.521Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1152_633",
    x: "0",
    y: "0",
    width: "56",
    height: "56",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: "2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1152_633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1152_633",
    result: "shape"
  }))));
}
GroupMessengerIcon.propTypes = {
  style: PropTypes.object
};
GroupMessengerIcon.defaultProps = {
  style: {}
};
GroupMessengerIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GroupMessengerIcon",
  "props": {
    "style": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    }
  }
};

/* eslint-disable max-len */
function InstagramIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      WebkitTransform: "translate3d(0,0,0)"
    },
    width: "66",
    height: "67",
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0091 4C21.3194 4 17.9006 4.01206 17.236 4.06721C14.8371 4.26667 13.3443 4.64449 11.7181 5.4544C10.4648 6.07691 9.47633 6.79851 8.50083 7.81005C6.72424 9.65476 5.64752 11.9242 5.25774 14.6219C5.06824 15.9316 5.01311 16.1987 5.00191 22.8882C4.99761 25.1181 5.00191 28.0527 5.00191 31.989C5.00191 43.6725 5.01483 47.0888 5.07082 47.7522C5.26463 50.0872 5.63072 51.5562 6.40596 53.1631C7.88753 56.2391 10.7171 58.5482 14.0507 59.4098C15.2049 59.7071 16.4798 59.8708 18.1164 59.9483C18.8098 59.9785 25.8774 60 32.9493 60C40.0212 60 47.0931 59.9914 47.7693 59.9569C49.6643 59.8677 50.7647 59.72 51.9814 59.4055C53.6343 58.9815 55.1747 58.2017 56.4951 57.1205C57.8155 56.0394 58.8841 54.6829 59.6261 53.1459C60.3863 51.5778 60.7717 50.0527 60.9462 47.8396C60.9841 47.3571 61 39.6642 61 31.9817C61 24.2978 60.9828 16.6192 60.9449 16.1367C60.7683 13.8879 60.3828 12.3757 59.5981 10.7774C58.9542 9.46908 58.2393 8.49201 57.2013 7.49297C55.3494 5.72322 53.0839 4.64621 50.384 4.25676C49.076 4.06764 48.8154 4.01163 42.1225 4H33.0091Z",
    fill: "url(#paint0_radial_1161_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0091 4C21.3194 4 17.9006 4.01206 17.236 4.06721C14.8371 4.26667 13.3443 4.64449 11.7181 5.4544C10.4648 6.07691 9.47633 6.79851 8.50083 7.81005C6.72424 9.65476 5.64752 11.9242 5.25774 14.6219C5.06824 15.9316 5.01311 16.1987 5.00191 22.8882C4.99761 25.1181 5.00191 28.0527 5.00191 31.989C5.00191 43.6725 5.01483 47.0888 5.07082 47.7522C5.26463 50.0872 5.63072 51.5562 6.40596 53.1631C7.88753 56.2391 10.7171 58.5482 14.0507 59.4098C15.2049 59.7071 16.4798 59.8708 18.1164 59.9483C18.8098 59.9785 25.8774 60 32.9493 60C40.0212 60 47.0931 59.9914 47.7693 59.9569C49.6643 59.8677 50.7647 59.72 51.9814 59.4055C53.6343 58.9815 55.1747 58.2017 56.4951 57.1205C57.8155 56.0394 58.8841 54.6829 59.6261 53.1459C60.3863 51.5778 60.7717 50.0527 60.9462 47.8396C60.9841 47.3571 61 39.6642 61 31.9817C61 24.2978 60.9828 16.6192 60.9449 16.1367C60.7683 13.8879 60.3828 12.3757 59.5981 10.7774C58.9542 9.46908 58.2393 8.49201 57.2013 7.49297C55.3494 5.72322 53.0839 4.64621 50.384 4.25676C49.076 4.06764 48.8154 4.01163 42.1225 4H33.0091Z",
    fill: "url(#paint1_radial_1161_495)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9956 11.3235C27.3812 11.3235 26.6766 11.348 24.4714 11.4484C22.2706 11.5492 20.7684 11.8978 19.4539 12.4091C18.0942 12.9373 16.9409 13.6438 15.7918 14.7936C14.6418 15.943 13.9355 17.0967 13.4058 18.4563C12.8932 19.7716 12.5444 21.2747 12.4453 23.4752C12.3471 25.6809 12.3213 26.3862 12.3213 32.0022C12.3213 37.6181 12.3463 38.3208 12.4462 40.5265C12.5474 42.7279 12.8958 44.2306 13.4066 45.5454C13.9351 46.9055 14.6414 48.0592 15.7909 49.2085C16.9396 50.3588 18.0929 51.067 19.4518 51.5952C20.7671 52.1066 22.2698 52.4551 24.4701 52.5559C26.6753 52.6563 27.3794 52.6808 32.9935 52.6808C38.6083 52.6808 39.3108 52.6563 41.5159 52.5559C43.7167 52.4551 45.2207 52.1066 46.536 51.5952C47.8953 51.067 49.0469 50.3588 50.1956 49.2085C51.3455 48.0592 52.0519 46.9055 52.5816 45.5458C53.0898 44.2306 53.4387 42.7275 53.542 40.5269C53.6411 38.3212 53.6669 37.6181 53.6669 32.0022C53.6669 26.3862 53.6411 25.6814 53.542 23.4757C53.4387 21.2742 53.0898 19.7716 52.5816 18.4568C52.0519 17.0967 51.3455 15.943 50.1956 14.7936C49.0457 13.6434 47.8957 12.9369 46.5347 12.4091C45.2168 11.8978 43.7137 11.5492 41.5129 11.4484C39.3078 11.348 38.6058 11.3235 32.9896 11.3235H32.9956ZM31.1411 15.05C31.6915 15.0491 32.3057 15.05 32.9956 15.05C38.5153 15.05 39.1695 15.0698 41.3493 15.1689C43.3649 15.2611 44.4588 15.5979 45.1875 15.881C46.1523 16.2558 46.8401 16.7038 47.5632 17.4276C48.2868 18.1513 48.7347 18.8406 49.1103 19.8056C49.3932 20.5337 49.7304 21.6279 49.8222 23.6441C49.9212 25.824 49.9428 26.4788 49.9428 31.9974C49.9428 37.516 49.9212 38.1709 49.8222 40.3507C49.73 42.3669 49.3932 43.4612 49.1103 44.1892C48.7356 45.1542 48.2868 45.8414 47.5632 46.5647C46.8397 47.2884 46.1527 47.7365 45.1875 48.1113C44.4597 48.3956 43.3649 48.7316 41.3493 48.8238C39.17 48.9229 38.5153 48.9445 32.9956 48.9445C27.4755 48.9445 26.8213 48.9229 24.642 48.8238C22.6264 48.7308 21.5324 48.3939 20.8033 48.1108C19.8385 47.736 19.1494 47.288 18.4259 46.5643C17.7023 45.8405 17.2544 45.1529 16.8788 44.1875C16.5959 43.4594 16.2586 42.3652 16.1669 40.349C16.0678 38.1691 16.048 37.5143 16.048 31.9923C16.048 26.4702 16.0678 25.8188 16.1669 23.6389C16.2591 21.6228 16.5959 20.5285 16.8788 19.7996C17.2535 18.8346 17.7023 18.1453 18.4259 17.4215C19.1494 16.6978 19.8385 16.2497 20.8033 15.8741C21.532 15.5898 22.6264 15.2537 24.642 15.1611C26.5491 15.0749 27.2881 15.0491 31.1411 15.0448V15.05ZM44.0307 18.4835C43.54 18.4835 43.0604 18.629 42.6524 18.9017C42.2444 19.1744 41.9264 19.562 41.7387 20.0155C41.551 20.469 41.5019 20.968 41.5977 21.4493C41.6935 21.9307 41.9298 22.3729 42.2769 22.7199C42.6239 23.0669 43.066 23.3031 43.5473 23.3988C44.0285 23.4944 44.5274 23.4452 44.9807 23.2572C45.4339 23.0693 45.8213 22.7511 46.0938 22.3429C46.3663 21.9347 46.5117 21.4549 46.5115 20.9641C46.5115 19.5941 45.4003 18.4826 44.0307 18.4826V18.4835ZM32.9956 21.3828C27.1327 21.3828 22.3792 26.1376 22.3792 32.0022C22.3792 37.8667 27.1327 42.6194 32.9956 42.6194C38.8586 42.6194 43.6108 37.8667 43.6108 32.0022C43.6108 26.1376 38.8581 21.3828 32.9952 21.3828H32.9956ZM32.9956 25.1093C36.8012 25.1093 39.8866 28.1951 39.8866 32.0022C39.8866 35.8088 36.8012 38.8951 32.9956 38.8951C29.1896 38.8951 26.1046 35.8088 26.1046 32.0022C26.1046 28.1951 29.1896 25.1093 32.9956 25.1093Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_495",
    x: "0",
    y: "0.5",
    width: "66",
    height: "66",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1.5"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_495"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1161_495",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1161_495",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8751 64.3132) rotate(-90) scale(55.5001 51.6195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.1",
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.5",
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1161_495",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-4.3803 8.03415) rotate(78.6806) scale(24.8088 102.263)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.128",
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#6600FF",
    stopOpacity: "0"
  }))));
}
InstagramIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InstagramIcon"
};

/* eslint-disable max-len */
function WhatsappIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      WebkitTransform: "translate3d(0,0,0)"
    },
    width: "66",
    height: "67",
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1161_466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8377 12.138C47.5733 6.89317 40.5734 4.0032 33.1154 4C17.747 4 5.24023 16.4477 5.23408 31.7478C5.23229 36.6385 6.51582 41.4126 8.95546 45.6208L5 60L19.7802 56.1415C23.8524 58.3526 28.4375 59.5177 33.1034 59.5196H33.1152H33.1154C48.4812 59.5196 60.9899 47.0696 60.9964 31.7703C60.999 24.3552 58.1013 17.3831 52.8377 12.138ZM33.1154 54.8328H33.1063C28.9474 54.8307 24.8689 53.719 21.3116 51.6174L20.465 51.1177L11.6941 53.4072L14.0358 44.8964L13.4842 44.0239C11.1643 40.3514 9.93961 36.1074 9.94136 31.7496C9.94646 19.0327 20.3416 8.68689 33.1241 8.68689C39.3141 8.68945 45.132 11.0916 49.5075 15.4509C53.8828 19.8102 56.2905 25.6052 56.2887 31.7683C56.2833 44.4856 45.8878 54.8328 33.1154 54.8328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28027 58.4041L10.0551 44.6818C7.72625 40.6658 6.50159 36.1094 6.50306 31.443C6.50916 16.8422 18.4447 4.96338 33.1098 4.96338C40.2275 4.96658 46.9079 7.72439 51.9306 12.7297C56.9544 17.735 59.7194 24.3881 59.7165 31.4637C59.7104 46.065 47.7741 57.9448 33.1109 57.9448C33.1098 57.9448 33.1116 57.9448 33.1109 57.9448H33.099C28.6463 57.9434 24.271 56.8305 20.385 54.722L6.28027 58.4041Z",
    fill: "url(#paint0_linear_1161_466)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2256 19.9676C25.7098 18.8258 25.1667 18.8029 24.6759 18.7829C24.2745 18.7658 23.815 18.7669 23.3562 18.7669C22.8971 18.7669 22.1509 18.9386 21.52 19.6247C20.8886 20.3108 19.1094 21.9693 19.1094 25.3425C19.1094 28.716 21.5773 31.9756 21.9213 32.4335C22.2657 32.8906 26.6855 40.0341 33.6851 42.7822C39.5024 45.0661 40.6862 44.6118 41.9489 44.4976C43.2115 44.3833 46.0231 42.8394 46.5971 41.2383C47.171 39.6376 47.171 38.2655 46.9989 37.9787C46.8267 37.693 46.3675 37.5216 45.6788 37.1787C44.99 36.8359 41.6045 35.177 40.9732 34.9484C40.3418 34.7198 39.8827 34.6055 39.4235 35.292C38.9643 35.9777 37.6453 37.5216 37.2436 37.9787C36.8418 38.4369 36.44 38.494 35.7513 38.1512C35.0626 37.8073 32.8446 37.084 30.2134 34.7483C28.1663 32.9312 26.7841 30.687 26.3823 30.0006C25.9806 29.3149 26.3393 28.9434 26.6847 28.6016C26.9939 28.2945 27.3735 27.8013 27.7178 27.4009C28.0615 27.0006 28.1763 26.7149 28.4058 26.2577C28.6354 25.7999 28.5206 25.3995 28.3484 25.0567C28.1763 24.7138 26.8379 21.3233 26.2256 19.9676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6097 12.0497C47.4058 6.86511 40.4862 4.00837 33.1139 4.00513C17.9219 4.00513 5.55876 16.31 5.55266 31.4344C5.55087 36.269 6.81965 40.9882 9.23128 45.1482L5.32129 59.3622L19.9318 55.548C23.9573 57.7336 28.4897 58.8854 33.102 58.8872H33.1137H33.1139C48.3033 58.8872 60.6682 46.5802 60.6747 31.4565C60.6772 24.1266 57.8129 17.2346 52.6097 12.0497ZM33.1139 54.2545H33.1049C28.9937 54.2523 24.9621 53.1534 21.4456 51.0759L20.6087 50.582L11.9385 52.8452L14.2533 44.4321L13.7081 43.5696C11.4148 39.9393 10.2041 35.744 10.2059 31.4362C10.2109 18.8653 20.4867 8.6383 33.1225 8.6383C39.2415 8.64081 44.9924 11.0154 49.3178 15.3247C53.6428 19.6339 56.0229 25.3624 56.0211 31.4548C56.0157 44.026 45.7396 54.2545 33.1139 54.2545Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1161_466",
    x: "0",
    y: "0.5",
    width: "65.9966",
    height: "66",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "1.5"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2.5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1161_466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1161_466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1161_466",
    x1: "32.9984",
    y1: "58.4041",
    x2: "32.9984",
    y2: "4.96347",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#60D66A"
  }))));
}
WhatsappIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WhatsappIcon"
};

/* eslint-disable max-len */
function MessengerIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      WebkitTransform: "translate3d(0,0,0)"
    },
    width: "56",
    height: "56",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "28",
    r: "28",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 12C18.9868 12 12 18.6024 12 27.52C12 32.1848 13.9116 36.2152 17.0248 39C17.1546 39.1149 17.2597 39.255 17.3336 39.4118C17.4076 39.5685 17.4488 39.7388 17.4548 39.912L17.542 42.76C17.5484 42.9696 17.6063 43.1743 17.7104 43.3563C17.8145 43.5383 17.9618 43.6919 18.1392 43.8037C18.3166 43.9154 18.5187 43.9819 18.7278 43.9972C18.9369 44.0126 19.1466 43.9763 19.3384 43.8916L22.514 42.4916C22.7831 42.373 23.0849 42.351 23.3684 42.4292C24.8779 42.8394 26.4357 43.0449 28 43.04C37.0132 43.04 44 36.44 44 27.52C44 18.6 37.0132 12 28 12ZM37.608 23.9412L32.908 31.4C32.7312 31.6805 32.4982 31.9213 32.2237 32.1072C31.9491 32.2931 31.6391 32.4202 31.313 32.4803C30.987 32.5404 30.652 32.5324 30.3292 32.4566C30.0064 32.3808 29.7028 32.239 29.4376 32.04L25.6996 29.236C25.5326 29.1108 25.3295 29.0435 25.1208 29.0441C24.9121 29.0448 24.7094 29.1134 24.5432 29.2396L19.4944 33.0696C18.8208 33.5808 17.9412 32.7744 18.392 32.0588L23.092 24.602C23.2688 24.3215 23.5018 24.0807 23.7763 23.8948C24.0509 23.7089 24.3609 23.5818 24.687 23.5217C25.013 23.4616 25.348 23.4696 25.6708 23.5454C25.9936 23.6212 26.2972 23.763 26.5624 23.962L30.3008 26.7656C30.4678 26.8908 30.6709 26.9581 30.8796 26.9575C31.0883 26.9568 31.291 26.8882 31.4572 26.762L36.5056 22.9308C37.1796 22.4192 38.0592 23.2256 37.608 23.9412Z",
    fill: "white"
  }));
}
MessengerIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MessengerIcon"
};

var TitleText = styled(Text)(function (props) {
  return {
    lineHeight: '39px',
    color: props.theme.colors.black.haptik
  };
});
function Title(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      margin: "10px 0",
      maxHeight: "120px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(TitleText, {
    variant: "display-1.bold"
  }, children));
}
Title.propTypes = {
  children: PropTypes.node.isRequired
};
Title.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Title",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};

function SubTitle(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxHeight: "64px",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body.lg",
    lineHeight: "22px"
  }, children));
}
SubTitle.propTypes = {
  children: PropTypes.node.isRequired
};
SubTitle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SubTitle",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    }
  }
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var colorMap = {
  "filled-whatsapp": "#0db350",
  "filled-instagram": "linear-gradient(90deg, #eea03f -13.26%, #e13322 55.25%, #bd2773 168.41%)",
  "filled-messenger": "#1877f2",
  "outline-whatsapp": "#0db350",
  "outline-instagram": "#c6019a",
  "outline-messenger": "#1877f2"
};
var Button = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 42px;\n  border-radius: ", ";\n  border: 0;\n  outline: none;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: \"Proxima Nova\", \"Roboto\", sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  margin-top: ", ";\n  &:hover {\n    transform: translate3d(0, -2px, 0);\n    box-shadow: 0 2px 4px rgb(0 0 0 / 20%);\n  }\n  ", "\n"])), function (props) {
  return "".concat(props.theme.radii.sm, "px");
}, function (props) {
  return "".concat(props.theme.space.md, "px");
}, function (props) {
  switch (props.variant) {
    case "filled":
      return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          color: ", ";\n          background: ", ";\n        "])), props.theme.colors.background, colorMap["filled-".concat(props.type)]);
    case "outline":
      return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          color: ", ";\n          background: ", ";\n          border: 1px solid ", ";\n          border-left: 6px solid ", ";\n          &:hover {\n            border-top: none;\n            border-right: none;\n            border-bottom: none;\n            color: ", ";\n            background: ", ";\n          }\n        "])), props.theme.colors.black.haptik, props.theme.colors.background, props.theme.colors.grey.haptik, colorMap["outline-".concat(props.type)], props.theme.colors.background, colorMap["outline-".concat(props.type)]);
    default:
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          background: white;\n        "])));
  }
});
function OmniButton(_ref) {
  var children = _ref.children,
    type = _ref.type,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement(Button, {
    variant: variant,
    type: type,
    "data-testid": "button-".concat(type)
  }, children);
}
OmniButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string.isRequired,
  variant: PropTypes.string
};
OmniButton.defaultProps = {
  variant: "filled"
};
OmniButton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "OmniButton",
  "props": {
    "variant": {
      "defaultValue": {
        "value": "\"filled\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": ""
    },
    "type": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};

function InstagramPrompt(_ref) {
  var header = _ref.header,
    body = _ref.body,
    channels = _ref.channels;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InstagramIcon, null), /*#__PURE__*/React.createElement(Title, null, header), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubTitle, null, body), /*#__PURE__*/React.createElement(OmniButton, {
    type: "instagram"
  }, channels[0].text)));
}
InstagramPrompt.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  })).isRequired
};
InstagramPrompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InstagramPrompt",
  "props": {
    "header": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "body": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "channels": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

function MessengerPrompt(_ref) {
  var header = _ref.header,
    body = _ref.body,
    channels = _ref.channels;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MessengerIcon, null), /*#__PURE__*/React.createElement(Title, null, header), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubTitle, null, body), /*#__PURE__*/React.createElement(OmniButton, {
    type: "messenger"
  }, channels[0].text)));
}
MessengerPrompt.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  })).isRequired
};
MessengerPrompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MessengerPrompt",
  "props": {
    "header": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "body": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "channels": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

function WhatsappPrompt(_ref) {
  var header = _ref.header,
    body = _ref.body,
    channels = _ref.channels;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WhatsappIcon, null), /*#__PURE__*/React.createElement(Title, null, header), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SubTitle, null, body), /*#__PURE__*/React.createElement(OmniButton, {
    type: "whatsapp"
  }, channels[0].text)));
}
WhatsappPrompt.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  })).isRequired
};
WhatsappPrompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WhatsappPrompt",
  "props": {
    "header": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "body": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "channels": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

/* eslint-disable max-len */
var IconComponentMap = {
  whatsapp: GroupWhatsappIcon,
  messenger: GroupMessengerIcon,
  instagram: GroupInstagramIcon
};
function AllIcons(_ref) {
  var _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, list.map(function (type, index) {
    var style = {
      marginLeft: index > 0 ? "-15px" : "0px",
      position: "relative",
      zIndex: list.length - index
    };
    var Component = IconComponentMap[type];
    return /*#__PURE__*/React.createElement(Component, {
      style: style,
      key: type
    });
  }));
}
AllIcons.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string)
};
AllIcons.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AllIcons",
  "props": {
    "list": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false,
      "description": ""
    }
  }
};

function AllPrompt(_ref) {
  var header = _ref.header,
    body = _ref.body,
    channels = _ref.channels;
  var IconList = channels.map(function (channel) {
    return channel.type;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AllIcons, {
    list: IconList
  }), /*#__PURE__*/React.createElement(Title, null, header), /*#__PURE__*/React.createElement(SubTitle, null, body), channels.map(function (channel) {
    return /*#__PURE__*/React.createElement(OmniButton, {
      variant: "outline",
      type: channel.type,
      key: channel.type
    }, channel.text);
  }));
}
AllPrompt.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  })).isRequired
};
AllPrompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AllPrompt",
  "props": {
    "header": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "body": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "channels": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

var PROMPT_TYPE = {
  WHATSAPP: "whatsapp",
  MESSENGER: "messenger",
  INSTAGRAM: "instagram",
  ALL: "all"
};

var normalisePromptData = function normalisePromptData() {
  var channels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var enabledChannels = channels.filter(function (channel) {
    return channel.enabled;
  });
  if (!enabledChannels || !enabledChannels.length) return null;
  if (enabledChannels.length >= 2) return {
    type: PROMPT_TYPE.ALL,
    enabledChannels: enabledChannels
  };
  return {
    type: enabledChannels[0].type,
    enabledChannels: enabledChannels
  };
};

/* eslint-disable react/jsx-props-no-spreading */
function Prompt(_ref) {
  var channels = _ref.channels,
    header = _ref.header,
    body = _ref.body;
  var data = normalisePromptData(channels);
  if (!data) return /*#__PURE__*/React.createElement("div", null, "Invalid bot prompt");
  var promptProps = {
    header: header,
    body: body,
    channels: data.enabledChannels
  };
  switch (data.type) {
    case PROMPT_TYPE.WHATSAPP:
      return /*#__PURE__*/React.createElement(WhatsappPrompt, promptProps);
    case PROMPT_TYPE.MESSENGER:
      return /*#__PURE__*/React.createElement(MessengerPrompt, promptProps);
    case PROMPT_TYPE.INSTAGRAM:
      return /*#__PURE__*/React.createElement(InstagramPrompt, promptProps);
    case PROMPT_TYPE.ALL:
      return /*#__PURE__*/React.createElement(AllPrompt, promptProps);
    default:
      return null;
  }
}
Prompt.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    enabled: PropTypes.bool,
    text: PropTypes.string,
    type: PropTypes.string
  })).isRequired
};
Prompt.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Prompt",
  "props": {
    "header": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "body": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    },
    "channels": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "enabled": {
              "name": "bool",
              "required": false
            },
            "text": {
              "name": "string",
              "required": false
            },
            "type": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

/* eslint-disable max-len */
function CrossIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    style: {
      cursor: "pointer"
    },
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3 2.1C13.6866 1.7134 13.6866 1.0866 13.3 0.7C12.9134 0.313401 12.2866 0.313401 11.9 0.7L7 5.6L2.1 0.7C1.7134 0.3134 1.0866 0.313401 0.7 0.7C0.313401 1.0866 0.313401 1.7134 0.7 2.1L5.6 7L0.699999 11.9C0.3134 12.2866 0.313401 12.9134 0.7 13.3C1.0866 13.6866 1.7134 13.6866 2.1 13.3L7 8.4L11.9 13.3C12.2866 13.6866 12.9134 13.6866 13.3 13.3C13.6866 12.9134 13.6866 12.2866 13.3 11.9L8.4 7L13.3 2.1Z",
    fill: "#595959"
  }));
}
CrossIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CrossIcon"
};

/* eslint-disable react/jsx-props-no-spreading */
var Container = styled("div")({
  background: "rgba(255, 255, 255, 0.55)",
  width: "294px",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  backdropFilter: "blur(8px)",
  "-webkit-backdrop-filter": "blur(8px)",
  "-moz-backdrop-filter": "blur(8px)",
  "-o-backdrop-filter": "blur(8px)",
  border: "1px solid rgba(255, 255, 255, 0.65)",
  borderRadius: function borderRadius(props) {
    return "".concat(props.theme.radii.sm, "px");
  },
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
});
function PromptContainer(_ref) {
  var config = _ref.config;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      right: "15px",
      top: "15px"
    },
    "data-testid": "prompt-cross-icon"
  }, /*#__PURE__*/React.createElement(CrossIcon, null)), /*#__PURE__*/React.createElement(Prompt, config));
}
PromptContainer.propTypes = {
  config: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    channels: PropTypes.arrayOf(PropTypes.shape({
      enabled: PropTypes.bool,
      text: PropTypes.string,
      type: PropTypes.string
    }))
  }).isRequired
};
PromptContainer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PromptContainer",
  "props": {
    "config": {
      "type": {
        "name": "shape",
        "value": {
          "header": {
            "name": "string",
            "required": false
          },
          "body": {
            "name": "string",
            "required": false
          },
          "channels": {
            "name": "arrayOf",
            "value": {
              "name": "shape",
              "value": {
                "enabled": {
                  "name": "bool",
                  "required": false
                },
                "text": {
                  "name": "string",
                  "required": false
                },
                "type": {
                  "name": "string",
                  "required": false
                }
              }
            },
            "required": false
          }
        }
      },
      "required": true,
      "description": ""
    }
  }
};

export default PromptContainer;
export { GroupInstagramIcon, GroupMessengerIcon, GroupWhatsappIcon, InstagramIcon, MessengerIcon, WhatsappIcon };
